var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0",staticStyle:{"height":"584px"}},[(_vm.active)?_c('div',[_c('player',{staticStyle:{"width":"60%"},attrs:{"uuid":_vm.id}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }